"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataSamplingFingerprint = exports.sortFingerprint = exports.attributeFingerprint = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
/**
 * @internal
 */
function attributeFingerprint(attribute) {
    ts_invariant_1.default(attribute, "attribute must not be undefined");
    return json_stable_stringify_1.default(attribute);
}
exports.attributeFingerprint = attributeFingerprint;
/**
 * @internal
 */
function sortFingerprint(sort) {
    return json_stable_stringify_1.default(sort);
}
exports.sortFingerprint = sortFingerprint;
/**
 * @internal
 */
function dataSamplingFingerprint(dataSamplingPercentage) {
    // Since data sampling is optional, we will have to handle undefined by returning a string
    return dataSamplingPercentage ? dataSamplingPercentage.toString() : "undefined";
}
exports.dataSamplingFingerprint = dataSamplingFingerprint;
//# sourceMappingURL=fingerprints.js.map